export const currencyCode = {
  USD: 'USD',
  EUR: 'EUR',
  GBP: 'GBP',
  CAD: 'CAD',
  AUD: 'AUD',
  JPY: 'JPY',
  CHF: 'CHF',
  MXN: 'MXN',
  INR: 'INR',
  CNY: 'CNY',
};

export const currencyData = {
  [currencyCode.USD]: {
    name: 'United States Dollar',
    symbol: '$',
    displayValue: 'United States Dollar (USD) – $',
    displayShortValue: 'USD',
  },
  [currencyCode.EUR]: {
    name: 'Euro',
    symbol: '€',
    displayValue: 'Euro (EUR) – €',
    displayShortValue: 'EUR',
  },
  [currencyCode.GBP]: {
    name: 'British Pound',
    symbol: '£',
    displayValue: 'British Pound (GBP) – £',
    displayShortValue: 'GBP',
  },
  [currencyCode.CAD]: {
    name: 'Canadian Dollar',
    symbol: '$',
    displayValue: 'Canadian Dollar (CAD) – $',
    displayShortValue: 'CAD',
  },
  [currencyCode.AUD]: {
    name: 'Australian Dollar',
    symbol: '$',
    displayValue: 'Australian Dollar (AUD) – $',
    displayShortValue: 'AUD',
  },
  [currencyCode.JPY]: {
    name: 'Japanese Yen',
    symbol: '¥',
    displayValue: 'Japanese Yen (JPY) – ¥',
    displayShortValue: 'JPY',
  },
  [currencyCode.CHF]: {
    name: 'Swiss Franc',
    symbol: 'CHF',
    displayValue: 'Swiss Franc (CHF) – CHF',
    displayShortValue: 'CHF',
  },
  [currencyCode.MXN]: {
    name: 'Mexican Peso',
    symbol: '$',
    displayValue: 'Mexican Peso (MXN) – $',
    displayShortValue: 'MXN',
  },
  [currencyCode.INR]: {
    name: 'Indian Rupee',
    symbol: '₹',
    displayValue: 'Indian Rupee (INR) – ₹',
    displayShortValue: 'INR',
  },
  [currencyCode.CNY]: {
    name: 'Chinese Yuan',
    symbol: '¥',
    displayValue: 'Chinese Yuan (CNY) – ¥',
    displayShortValue: 'CNY',
  },
};

export const getCurrentCurrencySymbolByCode = currencyCode => {
  return currencyData[currencyCode]?.symbol ?? '$';
};
